import React from 'react';
import './Footer.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';

const Footer = () => {
    return (
        <footer className="footer" style={{ backgroundColor: '#002244', color: 'white', padding: '40px 0' }}>
            <div className="container h-100">
                <div className="row" style={{ height: '600px' }}>
                    <div className="col-md-4 d-flex flex-column justify-content-center">
                        
                    </div>

                    <div className="col-md-4 d-flex flex-column justify-content-center">
                        <h5>Quick Links</h5>
                        <ul className="list-unstyled">
                            <li><a href="/" style={{ color: 'white' }}>Home</a></li>
                            <li><a href="/about-us" style={{ color: 'white' }}>About Us</a></li>
                            <li><a href="/academic" style={{ color: 'white' }}>Academic</a></li>
                            <li><a href="/courses" style={{ color: 'white' }}>Courses</a></li>
                            <li><a href="/career" style={{ color: 'white' }}>Career</a></li>
                        </ul>
                    </div>

                    <div className="col-md-4 d-flex flex-column justify-content-center">
                        <h5>Contact Us</h5>
                        <p>PWD Office:<br />
                        Plot number 904Block C, Street NumberC-9 National Police Foundation,<br />
                        Near Beacon House School, Sector o-9 Islamabad</p>
                        <p>Whatsapp: +923054479000</p>
                        <p>Phone: (051) 6127313</p><hr />
                        <p>Email: admissions@gateway.edu.pk</p><hr />
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col text-center">
                        <div className="social-icons mb-3">
                            <a href="https://facebook.com" className="text-decoration-none mx-2">
                                <FontAwesomeIcon icon={faFacebook} style={{ color: '#ffffff', fontSize: '24px' }} />
                            </a>
                            <a href="https://twitter.com" className="text-decoration-none mx-2">
                                <FontAwesomeIcon icon={faTwitter} style={{ color: '#ffffff', fontSize: '24px' }} />
                            </a>
                            <a href="https://instagram.com" className="text-decoration-none mx-2">
                                <FontAwesomeIcon icon={faInstagram} style={{ color: '#ffffff', fontSize: '24px' }} />
                            </a>
                            <a href="https://linkedin.com" className="text-decoration-none mx-2">
                                <FontAwesomeIcon icon={faLinkedin} style={{ color: '#ffffff', fontSize: '24px' }} />
                            </a>
                        </div>
                        <div className="copyright">
                            &copy; {new Date().getFullYear()} Gateway Educational Services. All rights reserved.
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
